import { JoinClubCta } from './JoinClubCta';

export default JoinClubCta;
